/***
*
*   MAGIC SIGN IN
*   Confirms magic token and redirects to dashboard if successful
*
**********/

import React, { useState, useContext, useEffect, useRef } from 'react';
import Axios from 'axios';
import { AuthContext, Animate, Row, Message, useNavigate } from 'components/lib';
import { useSearchParams } from 'react-router-dom';

export function MagicQuizSignin(props) {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token')
    const redirectLink = searchParams.get('assessment_link');
    const context = useRef(useContext(AuthContext));

    const [message, setMessage] = useState({

        type: 'info',
        title: 'Verifying Access',
        text: 'Please wait while we verify your assessment access...',

    });

    useEffect(() => {
        const verifyToken = async (token, redirectLink) => {
            try {
                //replace the url with new magic verify or modify existing one if needed
                const res = await Axios.post('/api/auth/magic/verify', { token: token, redirectLink: redirectLink });

                if (!res.data.onboarded) {
                    sessionStorage.setItem('redirectLink', redirectLink)
                }
                // res.data['2fa_required'] ? navigate(`/signin/otp?token=${res.data.token}`) :
                (res.status === 200 ? context.current.signin(res) : invalidLink())

            }
            catch (err) {

                invalidLink();

            }
        }

        if (token) {

            // check token exists
            verifyToken(token, redirectLink);

        }
        else {

            invalidLink();

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams, context, navigate]);

    function invalidLink() {
        setMessage({
            type: 'error',
            title: 'Assessment Link Is Invalid',
            text: 'This assessment link is no longer valid. It may have expired, been used already, or been closed by the creator. Please check your invitation or contact support if you believe this is an error.',
            buttonText: 'Go Back',
            buttonLink: '/signin'
        });
    }

    return (
        <Animate>
            <Row>
                <div style={{ width: '28em', margin: '0 auto' }}>
                    <Message
                        type={message.type}
                        title={message.title}
                        text={message.text}
                        buttonText={message.buttonText}
                        buttonLink={message.buttonLink}
                    />
                </div>
            </Row>
        </Animate>
    )
}
